<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new trip</small>
      </legend>
      <div>
        <form @submit.prevent="newTrip()">
          <div class="row">
            <input type="hidden" class="consignee_id" :value="Consignee.id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Loading date</label>
                <input type="date" class="form-control loading_date" required />
              </div>

              <div class="form-group">
                <label>Container Expiry date</label>
                <input
                  type="date"
                  class="form-control container_expiry_date"
                  required
                />
              </div>
              <div class="form-group">
                <label>From</label>
                <input
                  type="text"
                  class="form-control from"
                  placeholder="conatiner point of loading"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Container no</label>
                <input
                  type="text"
                  class="form-control container_no"
                  placeholder="container number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Truck</label>
                <select
                  class="form-control-lg form-control select2 truck_id"
                  required
                >
                  <option value>Select truck</option>
                  <option
                    v-for="truck in systemTruckallocations"
                    :value="truck.id"
                    :key="truck.id"
                  >
                    {{ truck.truck_no }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>To</label>
                <input
                  type="text"
                  class="form-control to"
                  placeholder="destination of the cargo/container"
                />
              </div>
            </div>
           
          </div>
          <div class="row">
              <div class="col-md-12">
                <div class="table-responsive" width="100">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Description</th>
                        <th scope="col">Unit price</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(trip_income, k) in tripIncomerows" :key="k">
                        <td scope="row">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="deleteRow(k, trip_income)"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                          <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, trip_income)"></i> -->
                        </td>
                        <td>
                        <input
                            class="form-control text-right"
                            type="text"
                            v-model="trip_income.description"
                          />
                        </td>
                        <td>
                          <input
                            class="form-control"
                            type="number"
                            min="0"
                            step=".01"
                            v-model="trip_income.unit_price"
                            @change="calculateLineTotal(trip_income)"
                          />
                        </td>
                        <td>
                          <input
                            readonly
                            class="form-control text-right"
                            type="number"
                            min="0"
                            step=".01"
                            v-model="trip_income.total"
                          />
                        </td>
                      </tr>
                      <tr v-show="tripIncomerows.length === 0">
                        <td colspan="4">
                          <p class="text-center alert-danger p-2">
                            No products added/available.
                          </p>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="3" class="text-right">Sub Total</td>
                        <input
                          readonly
                          class="form-control text-right sub_total"
                          type="number"
                          min="0"
                          step=".01"
                          :value="invoice_subtotal"
                        />
                      </tr>
                      <tr>
                        <td colspan="3" class="text-right">Total</td>
                        <input
                          readonly
                          class="form-control text-right grand_total"
                          type="number"
                          min="0"
                          step=".01"
                          :value="invoice_total"
                        />
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="col-md-12 mb-2">
                <button
                  type="button"
                  class="btn btn-info"
                  @click="addTripIncome"
                >
                  <i class="fa fa-plus-circle"></i>
                  Add
                </button>
              </div>
              <button
                type="submit"
                class="btn btn-primary btn-flat creatingTrip btn-rounded"
              >
                <i class="fa fa-plus"></i> create trip
              </button>
              <button
                type="button"
                class="btn-rounded btn-flat creatingTripLoader btn-rounded"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                please wait...
              </button>
            </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    if (this.$store.getters.Consignee.length === 0) {
      router.push("/trip");
    }
    this.loadAllocations();
  },
  computed: {
    ...mapGetters(["tripIncomerows", "Consignee", "systemTruckallocations"]),
  },
  methods: {
    ...mapActions(["loadAllocations","newTrip"]),
    ...mapMutations(["addTripIncome"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.tripIncomerows.reduce(function (sum, trip_income) {
        var lineTotal = parseFloat(trip_income.total);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(trip_income) {
      var total = parseFloat(trip_income.unit_price) * parseFloat(1);
      if (!isNaN(total)) {
        trip_income.total = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, trip_income) {
      var idx = this.tripIncomerows.indexOf(trip_income);

      if (idx > -1) {
        this.tripIncomerows.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingTripLoader{
    display: none
}
</style>


// WEBPACK FOOTER //
// src/trips/addtrip.vue